import { render, staticRenderFns } from "./PrecipitationCalculatorElement.vue?vue&type=template&id=64370672"
import script from "./PrecipitationCalculatorElement.vue?vue&type=script&lang=js"
export * from "./PrecipitationCalculatorElement.vue?vue&type=script&lang=js"
import style0 from "./PrecipitationCalculatorElement.vue?vue&type=style&index=0&id=64370672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports